const isKeyOf = <T extends object, K extends string>(
  object: T,
  key: K,
): key is keyof object => key in object;

export { isKeyOf };
